export interface IScrollToFirstErrorOptions {
    offset?: number;
    behavior?: ScrollBehavior;
    focus?: boolean;
    selectors?: string[];
}

const DEFAULT_SELECTORS = [
    '.has-error',
    '.is-invalid',
    '[aria-invalid="true"]',
    '.field-error',
];

export const scrollToFirstError = (options: IScrollToFirstErrorOptions = {}) => {
    const {
        offset = 120,
        behavior = 'smooth',
        focus = true,
        selectors = DEFAULT_SELECTORS,
    } = options;

    if (typeof document === 'undefined' || typeof window === 'undefined') { return; }

    const selector = selectors.join(', ');
    const nodes = Array.prototype.slice.call(
        document.querySelectorAll(selector),
    ) as HTMLElement[];

    if (!nodes.length) { return; }

    const first = nodes
        .map((el) => ({ el, top: el.getBoundingClientRect().top }))
        .sort((a, b) => a.top - b.top)[0].el;

    const rect = first.getBoundingClientRect();
    const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop || 0;

    const targetTop = currentScroll + rect.top - offset;

    window.scrollTo({ top: targetTop, behavior });

    if (focus) {
        const input = first.querySelector(
            'input, select, textarea, button, [tabindex]:not([tabindex="-1"])',
        ) as HTMLElement | null;

        if (input && typeof (input as any).focus === 'function') {
            (input as any).focus();
        }
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/util/scrollToFirstError.ts